import React from 'react';

import { Link, Spacer } from '@ontruck/orc';
import { injectIntl } from 'react-intl';

const CommentEdit = ({ className, comment, onClick, intl }) => {
  const t = intl.messages.modules.logs.log_item;
  return (
    <Spacer className={className}>
      <Link
        onClick={onClick}
        nude
        type="primary"
        text={comment ? t.edit_comment : t.add_comment}
        weight="bold"
      />
    </Spacer>
  );
};

export default injectIntl(CommentEdit);
